import { styled } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'

export const Header = styled(AppBar)({
  background: 'transparent',
  boxShadow: 'none',
})
